export default "__VITE_ASSET__2f50fa71__"